var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-field',{attrs:{"label":"Customer name"}},[_c('b-input',{attrs:{"minlength":"3","required":"","type":"text"},model:{value:(_vm.inputs.name),callback:function ($$v) {_vm.$set(_vm.inputs, "name", $$v)},expression:"inputs.name"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }